"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Grid = _interopRequireDefault(require("./Grid.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_Grid["default"]);

var Col = function Col(_ref) {
  var auto = _ref.auto,
      children = _ref.children,
      lgColumns = _ref.lgColumns,
      mdColumns = _ref.mdColumns,
      smColumns = _ref.smColumns,
      variation = _ref.variation,
      xsColumns = _ref.xsColumns,
      props = _objectWithoutProperties(_ref, ["auto", "children", "lgColumns", "mdColumns", "smColumns", "variation", "xsColumns"]);

  var classes = [cx({
    'col-auto': auto
  })];
  var breakpoints = {
    lg: lgColumns,
    md: mdColumns,
    sm: smColumns,
    xs: xsColumns
  };
  Object.entries(breakpoints).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        breakpoint = _ref3[0],
        value = _ref3[1];

    if (typeof value === 'number' && value >= 1 && value <= 12 || typeof value === 'string' && value === 'auto') {
      classes.push(cx("col-".concat(breakpoint, "-").concat(value)));
    } else if (typeof value === 'boolean' && value === true) {
      classes.push(cx("col-".concat(breakpoint)));
    }
  });

  if (variation !== null) {
    classes.push(cx("col-".concat(variation)));
  }

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: classes.join(' ')
  }, props), children);
};

Col.propTypes = {
  /** Auto width */
  auto: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming

  /** Content for the column */
  children: _propTypes["default"].node.isRequired,

  /** The number of cols (or auto) you wish to use in LG devices */
  lgColumns: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool]),

  /** The number of cols (or auto) you wish to use in MD devices */
  mdColumns: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool]),

  /** The number of cols (or auto) you wish to use in SM devices */
  smColumns: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool]),

  /** Col variation to handle special cases */
  variation: _propTypes["default"].oneOf(['calendar--single', 'calendar--double']),

  /** The number of cols (or auto) you wish to use in XS devices */
  xsColumns: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool])
};
Col.defaultProps = {
  auto: false,
  lgColumns: null,
  mdColumns: null,
  smColumns: null,
  variation: null,
  xsColumns: null
};
var _default = Col;
exports["default"] = _default;